<!--
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2022-11-15 14:05:50
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-02-24 11:32:08
 * @FilePath: \common_web\src\views\mineOrder\child.vue
-->
<template>
  <div class="mineOrder">
    <transition :name="transitionName" mode="out-in">
      <div>
        <div class="activeName ">

          <div class="search">
            <el-input :placeholder="$t('applyChild.pleInputCon')" v-model="input3" clearable class="input-with-select">
              <el-button slot="append" @click="search" icon="el-icon-search">{{ $t('tagsView.search') }}</el-button>
            </el-input>

          </div>
        </div>
        <div>
          <el-table :data="tableData" ref="tab" style="width: 100%">

            <el-table-column :label="item.label" v-for="(item, index) in columns" :key="index" :width="item.width"
              align="center" :prop="item.prop">

            </el-table-column>
            <el-table-column :label="$t('warehouse.quantity')" align="center">

              <template slot-scope="props">
                <!-- <el-input-number v-model="props.row.number" @change="e => handleChange(e, props.row)"
                  :min="1"></el-input-number> -->
                <div @click="handleChange(props.row)">
                  <el-input v-model="props.row.number" readonly class="inputnumber"></el-input>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="page">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper" :total="totals">
          </el-pagination>
        </div> -->
      </div>

    </transition>
    <el-dialog :visible="visible" @close="close" width="30%" :title="$t('warehouse.modifyQuantity')">
      <div class="radio">
        <el-radio-group v-model="radio">
          <el-radio :label="3">{{$t('warehouse.increase')}}</el-radio>
          <el-radio :label="6">{{$t('warehouse.decrease')}}</el-radio>

        </el-radio-group>
      </div>
      <div class="input">
        <el-input v-model="value" type="number" min="0"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">{{$t('warehouse.cancel')}}</el-button>
        <el-button type="primary" @click="confirm" :loading="loading">{{$t('warehouse.confirm')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>

import { productPage, updatenumber, maintenancecheck, shopApplyDevicedetail } from '@/api/addDevice.js'
export default {
  data() {
    return {
      tableData: [],
      page: {
        size: 10,
        current: 1,
      },
      value:0,
      totals: 0,
      columns: [
        { label: this.$t('warehouse.serialNumber'), prop: "index", width: 80 },

        { label: this.$t('warehouse.name'), prop: "name" },
        { label: this.$t('warehouse.code'), prop: "code" },
        { label: this.$t('warehouse.model'), prop: "model" },
        { label: this.$t('warehouse.specification'), prop: "specification" },
        // { label: this.$t('warehouse.quantity'), prop: "number" },

      ],
      transitionName: "fade",
      isdetail: false,
      input3: '',
      devId: '',
      defaultList: [
        { name: this.$t('checkChild.totalCode'), val: "generalCode", url: 'genArchivelist', option: 'genoptions', label: 'code' },
        { name: this.$t('checkChild.totalName'), val: "generalName", url: 'genArchivelist', option: 'genoptions', label: 'name' },
        { name: this.$t('warehouseDetail.orderNum'), val: "orderCode", url: 'gencodeList', option: 'codeoptions', label: 'orderCode' },
        { name: this.$t('warehouseDetail.bankNum'), val: "bankCard", url: 'genArchiveBanklist', option: 'bankoptions', label: 'bankCard' },
        { name: this.$t('logsIndex.time'), val: "timer", url: '', option: '', label: '', type: "time" },
      ],
      visible: false,
      searchObj: {},
      id: "",
      radio: 3,
      loading:false,
      checkInfo:''
    };
  },
  mounted() {
    if (this.$route.query.type) {

      this.id = this.$route.query.id;
    }
    this.getgeneralItemOrderPage()

  },
  props: {
    isware: {
      type: Boolean
    }
  },
  // components: { ChildDetail,Filterval },
  methods: {
    handleChange(e, item) {
      console.log(e, item)
      this.checkInfo = e
      this.visible = true
      // let obj = { productId: item.id, number: e, generalCode: this.id }
      // updatenumber(obj).then(res => {
      //   this.getgeneralItemOrderPage()

      // })
    },

    confirm(){
      this.loading = true
      let obj = {
        productId:this.checkInfo.id,
        number:this.radio == 3?this.value:this.value*-1,
        generalCode:this.id
      }
      updatenumber(obj).then(res => {
        if (res.data.code == 200) {

          this.visible = false
          this.getgeneralItemOrderPage()
        }
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    getgeneralItemOrderPage() {
      productPage({ searchKey: this.input3, generalCode: this.id }).then(res => {

        if (res.data.code == 200) {
          res = res.data.data
          res.map((item, i) => {
            item.index = i + 1
          })

          this.tableData = res
          // this.totals = res.total
          // this.page.current = res.current


        }
      })
    },


    search() {
      this.page.current = 1
      this.getgeneralItemOrderPage()
    },
    handleClick(e) {
      console.log(e, this.activeName)
      this.page.current = 1
      this.getgeneralItemOrderPage()
    },


    handleSizeChange(e) {
      this.page.size = e
      this.getgeneralItemOrderPage()
    },
    handleCurrentChange(e) {
      this.page.current = e
      this.getgeneralItemOrderPage()
    },
    goblack(e) {
      this.isdetail = false
      if (e) {
        this.getgeneralItemOrderPage()
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.togglerow(this.tableData);
        })
      }, 500)
    }
  },
};
</script>
<style lang="scss">
.mineOrder {
  .inputnumber{
    input{
      text-align: center;
    }
  }
  .radio{
    padding-left: 16%;
  }
  .input{
    padding-left: 16%;
    margin-top:20px;
    width: 80%;
  }
  // background: #F2F6F9;
  .el-tabs__item {
    height: 60px;
    line-height: 60px;
  }

  .el-tabs__header {
    margin: 0 0 1px;
  }

  .el-table__expanded-cell {
    padding: 0 0 0 50px !important;
  }

  .el-tabs__nav-wrap::after {
    height: 0;
  }

  .tabchild {
    .el-table__header-wrapper {
      display: none;
    }
  }

  .warning-row {
    background: #f4f5fa;
  }

  .page {
    margin: 20px 0;
    text-align: end;
  }

  .activeName {
    background: #fff;

    padding: 16px 16px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;


    .search {
      display: flex;
      align-items: center;

      .advance-filter {
        cursor: pointer;
        margin-left: 20px;
        display: flex;
        align-items: center;
        white-space: nowrap;
      }
    }
  }

  .tabflex {
    // display: flex;
    // justify-content: space-around;
    text-align: left;
  }

  .devinfo {
    display: flex;
    align-items: center;
    justify-content: center;

    &_left {
      width: 100px;
      height: 100px;
      margin-right: 10px;
    }

    &_right {
      // height: 100px;
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .bold {
        font-weight: bold;
      }

      p {
        flex: 1;
      }
    }
  }
}
</style>
